import React from 'react';
import {PrimaryButton, SkeletonLoader} from '../../components';
import {copyWhite, logo, placeholder} from '../../assets/images/images';
import {toast} from 'react-toastify';

export const QrCode = ({
  isLoading,
  _2FAData,
  setOTPOpen,
  showLogo,
  className,
}) => {
  const copyText = text => {
    navigator.clipboard.writeText(text);
    toast.success('Secret copied');
  };
  return (
    <div className={`${className}`}>
      {showLogo && <img src={logo} alt="Dojah logo" className="max-h-[50px]" />}
      <section className="mt-10 text-left">
        <h2 className="mb-1 text-body">Setup 2 Factor Authentication (2FA)</h2>
        <p className="text-[11px] text-grey-500 font-thin">
          Dojah can help you onboard users and perform KYC more efficiently at
          the same time
        </p>

        <div className="my-8 flex justify-center items-center flex-col gap-5 border border-grey5 p-10 rounded-lg">
          {isLoading ? (
            <SkeletonLoader
              style={{
                height: 300,
              }}
              className="before:h-full"
            />
          ) : (
            <img
              src={_2FAData?.qrCode || placeholder}
              alt=""
              className={`${_2FAData?.qrCode && 'h-[300px]'}`}
              width={300}
            />
          )}
          <h2 className="w-[200px] text-center">
            Scan QR code with your authenticator app
          </h2>
        </div>
        <p className="text-center">Or enter manually</p>

        <div className="my-8">
          <p className=" text-sm text-grey-500 ">Enter manually</p>
          <div className="relative  my-6">
            <p className="text-body pl-6 relative text-[14px]  overflow-auto  ">
              {(_2FAData?.secret &&
                `${_2FAData?.secret?.substring(0, 20)}...`) ||
                'Secret will appear here...'}
            </p>
            <button
              onClick={() => copyText(_2FAData?.secret)}
              className="absolute flex items-center gap-2 p-2 -translate-y-1/2 border rounded top-2/4 right-4 bg-brandBlue"
            >
              <img src={copyWhite} alt="" width={14} height={14} />
              <span className="text-sm font-medium text-white">Copy</span>
            </button>
          </div>
        </div>

        <PrimaryButton
          onClick={setOTPOpen}
          buttonText="Continue"
          className="w-full mt-4"
          disabled={!_2FAData}
        />
      </section>
    </div>
  );
};
